import React from 'react';
import { SegmentedControlWrapper, SegmentedTrack, SegmentedItem } from './index.styles';
import type { Tab } from '../../types';

interface SegmentedControlProps {
  tabs: Tab[];
  activeTabIndex: number;
  onTabChange: (index: number) => void;
  trackBg?: string | null;
  activeItemBg?: string | null;
  activeItemTextColor?: string | null;
  ariaLabel?: string;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({
  tabs,
  activeTabIndex,
  onTabChange,
  trackBg,
  activeItemBg,
  activeItemTextColor,
  ariaLabel = 'Plans',
}) => (
  <SegmentedControlWrapper>
    <SegmentedTrack role="group" aria-label={ariaLabel} $trackBg={trackBg}>
      {tabs.map((tab, index) => (
        <SegmentedItem
          key={tab.id}
          id={`tab-${tab.id}`}
          aria-pressed={activeTabIndex === index}
          $active={activeTabIndex === index}
          $activeBg={activeItemBg}
          $activeTextColor={activeItemTextColor}
          onClick={() => onTabChange(index)}
          type="button"
        >
          {tab.label}
        </SegmentedItem>
      ))}
    </SegmentedTrack>
  </SegmentedControlWrapper>
);

export default SegmentedControl;
